import cn from "classnames"

import { Paragraph } from "@/atoms"

import styles from "./PackageVersion.module.scss"

import type { PackageVersionsComponent } from "."

export const PackageVersions: PackageVersionsComponent = (props) => {
  const { name, version, displayValueInTooltip, rows = 2, classes = {} } = props

  if (!name && !version) return <span>-</span>

  const displayValue = `${name} ${version}`

  return (
    <Paragraph
      className={cn(styles.container, classes.container)}
      ellipsis={{
        rows,
        tooltip: {
          title: displayValueInTooltip ? displayValue : version,
          rootClassName: cn("root-class-tooltip-antd-ks", styles.tooltip)
        }
      }}
    >
      {displayValue}
    </Paragraph>
  )
}
